module.exports = __webpack_public_path__ + "icon_kartat.e94ecab4f3802b12e6a2.svg";